import Global from 'models/Global';
import BootstrapData from 'models/BootstrapData';
import MainBaseView from 'views/MainBaseView';
import { addTransifexListeners } from 'utils/TransifexUtils';

const EditRegistrationView = MainBaseView.extend({
    initialize: function() {
        MainBaseView.prototype.initialize.apply(this, arguments);
        const event = Global.get('event');
        addTransifexListeners(event.attributes);
    }
});

const event = BootstrapData('bootstrap-data-event');
export default new EditRegistrationView({
    bootstrapData: {
        event: event
    }
});
